import React, { useState } from 'react'
import fileexpico from '../icons/fileExplorer.png'
import minimizeIcons from '../icons/minimize.png'
import maximizeIcons from '../icons/maximize.png'
import closeIcon from '../icons/close.png'
import { AiOutlinePlusCircle } from 'react-icons/ai';
import { BsScissors, BsGrid } from 'react-icons/bs';
import { MdContentCopy } from 'react-icons/md';
import { RxClipboardCopy } from 'react-icons/rx';
import { RiFolderSharedLine } from 'react-icons/ri';
import { CgScan } from 'react-icons/cg';
import { BiSortAlt2 } from 'react-icons/bi';

const ThisPc = ({ closeWindow, resizeWindow, minimizeWindow, resize, close, minimize }) => {


  return (
    <div className={`${close ? '' : 'translate-y-full hidden'} bg-white ${resize ? 'w-[100vw]' : 'w-[60vw]'} ${resize ? 'h-[100vh]' : 'h-[75vh]'} rounded-md overflow-hidden transition-all ease-in-out delay-200`}>
      {/* heade rstart */}
      <div className="header flex flex-col justify-between bg-[#ddd]">
        <div className='flex justify-between pb-3'>
          <div className='left flex items-center'>
            <img className='w-4 mx-2' src={fileexpico} alt="icons" />
            <span className='text-xs'>File Explorer</span>
          </div>
          <div className='right flex items-center'>
            <div onClick={minimizeWindow} className='flex justify-center items-center w-10 h-7 p-3 hover:bg-gray-200'><img src={minimizeIcons} alt="icon" /></div>
            <div onClick={resizeWindow} className='flex justify-center items-center w-10 h-7 p-3 hover:bg-gray-200'><img src={maximizeIcons} alt="icon" /></div>
            <div onClick={closeWindow} className='flex justify-center items-center w-10 h-7 p-3 hover:bg-red-600'><img src={closeIcon} alt="icon" /></div>
          </div>
        </div>

        <div className='flex py-1'>

          <div className='flex items-center space-x-1 border-gray-400 border-r-2 w-fit py-2 px-5'>
            <AiOutlinePlusCircle />
            <span>New</span>
          </div>

          <hr />

          <div className='flex items-center space-x-8 border-gray-400 border-r-2 w-fit py-2 px-5'>
            <BsScissors />
            <MdContentCopy />
            <RxClipboardCopy />
            <CgScan />
            <RiFolderSharedLine />
          </div>

          <div className='flex space-x-3 px-5'>

            <div className='flex items-center space-x-1'>
              <BiSortAlt2/>
              <span className='text-sm'>Sort</span>
            </div>

            <div className='flex items-center space-x-1'>
              <BsGrid/>
              <span className='text-sm'>View</span>
            </div>

          </div>

        </div>

      </div>
      <hr className="h-px bg-gray-200 border-0 dark:bg-gray-700"/>
      {/* header end */}


    </div>
  )
}

export default ThisPc
